import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Write sitting down, edit standing up",
  "description": "",
  "published": "2013-05-09T00:00:00.000Z",
  "redirect_from": ["/blog/write-sitting-down-edit-standing-up/swizec/6175"],
  "categories": "editing, Word count, Writing, Writing",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`On March 26th I giddily said `}<a parentName="p" {...{
        "href": "http://swizec.com/blog/it-takes-about-two-months-to-write-a-technical-book/swizec/6076"
      }}>{`it takes about two months to write a technical book`}</a>{`. Still high from the recent success it seemed like the thing to do.`}</p>
    <p><img parentName="p" {...{
        "src": "https://images.elephantjournal.com/wp-content/uploads/2010/04/Picture-359.png",
        "alt": "Hemingway writing",
        "title": "Hemingway writing"
      }}></img></p>
    <p>{`It is now May 9th. I am `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Film_editing",
        "title": "Film editing"
      }}>{`editing`}</a>{`.`}</p>
    <p>{`Well, sort of. I had thought my writing was awesome, that there will be hardly any editing needed and on 9th of April, just two weeks later, there was a reality check in my inbox.`}</p>
    <p>{`It was the editor: "Hey this is really great, solid writing, I just fixed some spelling and markup for ya."`}</p>
    <p>{`And truly, all the fixes were either typos or `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/British_English",
        "title": "British English"
      }}>{`British English`}</a>{` - they want American. Something about markets.`}</p>
    <p>{`"Oh and shorten the book by 60 pages. We said 100, you wrote 180, we can do 120 tops."`}</p>
    <p><em parentName="p">{`*`}{`gulp`}{`*`}</em></p>
    <p>{`It is now May 9th. I am editing.`}</p>
    <p>{`The stickler is that my beta readers said they'd like even `}<em parentName="p">{`more`}</em>{` content in the book, definitely not less. Obviously I can't cut any content out of the book and I can't make the code examples shorter either. People have already complained the examples are a bit terse and hard to understand at moments.`}</p>
    <p>{`I could take out some screenshots, but this is a book about creating shiny visualisations for the internet. Screenshots must stay.`}</p>
    <p>{`Only thing left is the writing. I have to go through the whole book and use less words to say more.`}</p>
    <p><em parentName="p">{`*`}{`gulp`}{`*`}</em></p>
    <p>{`Facing such a monumental task it is therefore not a surprise I've only spent about 30 hours editing my book in the last month. That's averaging just an hour per day - the average for writing was two and a half.`}</p>
    <p>{`And editing time isn't even half as efficient as writing time. For every two minutes of staring bleary eyed at the screen, dragging the words through my mind like so much barbed wire, I spend five minutes prancing about on the internet feeling like I'm riding a unicorn in comparison.`}</p>
    <p>{`Editing really is sheer drudgery. There is no flow. There is no inspiration. Just a constant ruthless cutting and rewording. All those little things you thought added a special flair to the writing, let your personality shine through, entertained the reader.`}</p>
    <p>{`Waste. Plain old waste. Vomit of a writer who's been staring at the screen too long.`}</p>
    <p>{`It all has to go.`}</p>
    <p>{`And the writing is `}<em parentName="p">{`much`}</em>{` better for it. But you're still sad to see it all go.`}</p>
    <p>{`Actually, not so much sad, as indifferent. You don't feel anything but the monotonous drudgery of rewriting something you've already written and not coming up with anything new. You can't, add something new and the word count goes up not down. Can't have that!`}</p>
    <p>{`It's been fairly successful too. I've finished the first two chapters. One cut down from 14 to 9 pages, the other from 51 to 40. Just by improving the writing. No loss of content.`}</p>
    <p>{`But it's just so ... it's terrible.`}</p>
    <p>{`This weekend I discovered a trick, though. I was at a friend's place and as I was editing in the kitchen I realized that the chairs are terrible and the table is the wrong height.`}</p>
    <p>{`Peeved, I moved to the counter. Editing standing next to the kitchen counter, shoulders slouched to stare at the screen ...`}</p>
    <p>{`... before I knew it, two hours had passed and I edited five pages of text. Amazing! I had fallen into flow. `}<em parentName="p">{`Editing!`}</em>{` Flow!`}</p>
    <p>{`I don't actually know if this was because of my friend's kitchen or because I was standing while writing. But I'm going to repeat the experiment today.`}</p>
    <p>{`Fingers crossed it works!`}</p>
    <p><a parentName="p" {...{
        "href": "http://www.zemanta.com/?px",
        "title": "Enhanced by Zemanta"
      }}><img parentName="a" {...{
          "src": "https://img.zemanta.com/zemified_e.png?x-id=1c1fccc8-b519-4743-bf53-a2da2f56481a",
          "alt": "Enhanced by Zemanta"
        }}></img></a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      